import { z } from 'zod/v4';

export const CompanyBulkUnlinkBodySchema = z.object({
  forCompanyIds: z
    .array(z.string().min(1))
    .min(1)
    .refine(ids => new Set(ids).size === ids.length, {
      message: 'forCompanyIds must not contain duplicates',
    }),
});

export type CompanyBulkUnlinkBody = z.infer<typeof CompanyBulkUnlinkBodySchema>;
